import {Component, TemplateRef} from '@angular/core';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent {
  constructor(public alert: AlertService) {}

  isTemplate(toast) { return toast.textOrTpl instanceof TemplateRef; }
}